/* eslint-disable */
// TODO: conver to functional component
import React from "react";
import PropTypes from "prop-types";
import Component from "components/component";
import { addImgixParams } from "../../lib/helpers";

export default class VariationImage extends Component {
  static propTypes = {
    src: PropTypes.string,
    initialSrc: PropTypes.string,
    openModal: PropTypes.func,
    imgixParams: PropTypes.object,
    updateURL: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
    hasVariationImages: PropTypes.bool
  };

  static defaultProps = {
    imgixParams: {}
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      lastValidSrc: props.initialSrc,
      srcIsValid: isValidSrc(props.src)
    };
  }

  shouldComponentUpdate(newProps, newState) {
    if (!isValidSrc(newProps.src)) {
      return false;
    }

    return (
      newProps.src !== this.props.src ||
      newProps.hasError !== this.props.hasError ||
      newState.loading !== this.state.loading ||
      newState.lastValidSrc !== this.state.lastValidSrc ||
      newState.srcIsValid !== this.state.srcIsValid
    );
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.src !== this.props.src) {
      const srcIsValid = isValidSrc(newProps.src);
      let loading = srcIsValid;

      // If transitioning from an invalid source to valid one,
      // don't set loading to true as we don't need to load an image
      // that's already loaded.
      if (srcIsValid && !this.state.srcIsValid) {
        loading = false;
      }

      this.setState(
        {
          loading: loading,
          srcIsValid: srcIsValid
        },
        () => {
          if (!srcIsValid) {
            this.props.updateURL(this.state.lastValidSrc);
          }
        }
      );
    }
  }

  render() {
    const { loading, lastValidSrc } = this.state;
    let {
      src,
      imgixParams,
      openModal,
      hasError,
      hasVariationImages
    } = this.props;

    return (
      <div className="product-quote-image-inner">
        {hasError &&
          hasVariationImages && (
            <div className="image-error-message-overlay">
              <div className="image-error-message">
                <span className="image-error-header">Note</span>
                <span>No Preview Image Available</span>
              </div>
            </div>
          )}

        <img
          src={addImgixParams(lastValidSrc, imgixParams)}
          className="loading"
          style={{ display: loading ? "block" : "none" }}
        />

        <img
          src={addImgixParams(src, imgixParams)}
          onClick={this.onClick.bind(this, src)}
          onLoad={this.onLoad}
          onError={this.onError}
          className="valid"
          style={{ display: loading ? "none" : "block" }}
        />

        {!hasError &&
          openModal && (
            <button
              className={loading ? "view-loading" : "view-zoomed"}
              onClick={this.onClick.bind(this, src)}
            />
          )}
      </div>
    );
  }

  onLoad = e => {
    let state = { loading: false };

    if (this.state.srcIsValid) {
      state.lastValidSrc = this.props.src;
    }

    this.setState(state);
  };

  onError = e => {
    this.setState(
      {
        loading: false,
        srcIsValid: false
      },
      () => {
        this.props.updateURL(this.state.lastValidSrc);
      }
    );
  };

  onClick = (src, e) => {
    e.preventDefault();
    const url = addImgixParams(src, { w: 1280 });
    this.props.openModal("product-zoom", { imgSrc: url });
  };
}

function isValidSrc(src) {
  return /^http/.test(src);
}
